var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhyIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54 73.0968V76.8064C54 79.6703 56.3137 82 59.1579 82H76.8421C79.6863 82 82 79.6703 82 76.8064V73.0968H54ZM82 68.6452V41.1935C82 38.3297 79.6863 36 76.8421 36H59.1579C56.3137 36 54 38.3297 54 41.1935V68.6452H82Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59 31.7297C59 31.7297 77.7489 31.7111 78 31.7297V29.2027C78 26.3338 75.6136 24 72.68 24H45.32C42.3864 24 40 26.3338 40 29.2027V65.6216H49.12V41.3919C49.12 36.0643 53.5523 31.7297 59 31.7297ZM49.12 70.0811H40V73.7973C40 76.6662 42.3864 79 45.32 79H49.319C49.1866 78.364 49.1199 77.7166 49.12 77.0676V70.0811Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5975 19.4043H72.2924C73.5653 19.403 74.8257 19.6566 76 20.1501V14.1915C76 9.67455 72.341 6 67.8432 6H14.1568C9.65898 6 6 9.67455 6 14.1915V40.2553H35.9576V29.0851C35.9576 23.7472 40.2822 19.4043 45.5975 19.4043ZM6 44.7234V45.4681C6 49.985 9.65898 53.6596 14.1568 53.6596H35.9576V44.7234H6ZM35.9576 58.1277H30.4981L27.5309 67.0668C23.9015 67.1323 20.9788 70.1054 20.9788 73.766C20.9788 74.9999 21.9747 76 23.2034 76H35.9576",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyIcon3);
export default __webpack_public_path__ + "static/media/why-icon3.bed28ec69cf13c4dbde44c1102abce00.svg";
export { ForwardRef as ReactComponent };